<script setup lang="ts">
const modelValue = defineModel<boolean>('modelValue', {
  default: false,
});

const isChecked = computed<boolean>(() => {
  return !!modelValue.value;
});

function onCheckboxChanges() {
  modelValue.value = !modelValue.value;
}
</script>

<template>
  <div class="inputToggle">
    <label class="container">
      <input
        v-bind="$attrs"
        :checked="isChecked"
        class="input"
        type="checkbox"
        @change="onCheckboxChanges"
      />
      <span class="switch"></span>
    </label>
  </div>
</template>

<style lang="scss">
.inputToggle {
  @apply flex items-center justify-center relative z-10;

  --switch-container-width: 36px;
  width: var(--switch-container-width);

  .container {
    @apply cursor-pointer flex items-center;

    .input {
      @apply absolute w-px h-px p-0 -m-px overflow-hidden whitespace-nowrap border-0;

      clip: rect(0, 0, 0, 0);
    }

    .switch {
      @apply flex items-center relative bg-texts/15 border-texts/10 border border-solid flex-shrink-0 shadow-md shadow-black/5;

      --switch-size: calc(var(--switch-container-width) / 1.8);
      height: var(--switch-size);
      flex-basis: var(--switch-container-width);
      border-radius: var(--switch-size);
      transition: background-color 180ms ease-in-out;

      &::before {
        @apply content-[''] absolute left-0 rounded-full bg-texts/50 z-10 shadow-md shadow-black/30;

        height: calc(var(--switch-size) - 1px);
        width: calc(var(--switch-size) - 1px);
        transition: transform 250ms ease-in-out;
      }
    }

    .input:checked + .switch {
      @apply bg-primary;
    }

    .input:checked + .switch::before {
      @apply bg-white/90;
      transform: translateX(
        calc(var(--switch-container-width) - var(--switch-size))
      );
    }

    .input:focus:checked + .switch::before {
      @apply border-primary;
    }
  }
}
</style>
